module.exports = __webpack_public_path__ + "img/zhuanzhang.372c7a8d.png";